import { FC, ReactNode } from 'react';
import Text, {
  TextColors,
  TextPresets,
} from '@stripcash/ui-kit/components/Text';
import cn from 'classnames';

import { Translate } from 'common/i18n/types';

import s from './styles.module.css';
import { RATE_SMILES } from './constants';

type SmilesGroupSwitchProps = {
  value?: number;
  onSelect?: (value: number) => void;
  t?: Translate;
  isPreview?: boolean;
};

const SmilesGroupSwitch: FC<SmilesGroupSwitchProps> = ({
  value,
  onSelect,
  t,
  isPreview = false,
}) => (
  <div
    className={cn(s.smileRateGroup, { [s.smileRateGroupPreview]: isPreview })}
  >
    {RATE_SMILES(t).map(({ emoji, title, id }) =>
      onSelect ? (
        <button
          disabled={isPreview}
          key={id}
          type="button"
          onClick={() => onSelect(id)}
          className={cn(s.smileRateBtn, {
            [s.smileRateBtnActive]: value === id,
            [s.smileRateBtnPreview]: isPreview,
          })}
        >
          {emoji}
          <Text preset={TextPresets.Body10} color={TextColors.Gray}>
            {title as ReactNode}
          </Text>
        </button>
      ) : (
        <div key={id} className={s.smileRateItem}>
          {emoji}
        </div>
      ),
    )}
  </div>
);

export default SmilesGroupSwitch;
